import type { Rgba } from 'types/cms/Rgba';

export const getRGBA = ({ a, r, g, b }: Rgba) => `rgba(${r}, ${g}, ${b}, ${a})`;
